import { render, staticRenderFns } from "./initconfig.vue?vue&type=template&id=5db17bd7&"
import script from "./initconfig.vue?vue&type=script&lang=js&"
export * from "./initconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports